import {api} from "../../shared/utils";
import {environment} from "../../config/environment";

const baseUrl = environment.apiBaseURLClients;

const ENDPOINTS = {
    sistemas: '/sistemas',
    modulos: '/modulos',
    funcionalidades: '/funcionalidades',
    recursos: '/recursos',
    metricas: '/metricas',
};

const buildQuery = (params = {}) => {
    const query = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '') return;
        query.set(key, value);
    });

    return query.toString();
};

export const listCatalogEntity = (entityKey, params = {}) => {
    const query = buildQuery(params);
    const url = `${baseUrl}${ENDPOINTS[entityKey]}${query ? `?${query}` : ''}`;
    return api.get(url);
};

export const createCatalogEntity = (entityKey, payload) => api.post(`${baseUrl}${ENDPOINTS[entityKey]}`, payload);

export const updateCatalogEntity = (entityKey, id, payload) => api.put(`${baseUrl}${ENDPOINTS[entityKey]}/${id}`, payload);

export const deleteCatalogEntity = (entityKey, id) => api.delete(`${baseUrl}${ENDPOINTS[entityKey]}/${id}`);

export const getCatalogEntity = (entityKey, id) => api.get(`${baseUrl}${ENDPOINTS[entityKey]}/${id}`);

// Pendências e "Pôr à venda" do sistema (BBF-173). O 409 do "Pôr à venda" traz a lista em `valor`.
export const getPendencias = (sistemaId) => api.get(`${baseUrl}/sistemas/${sistemaId}/pendencias`);

export const porAVenda = (sistemaId) => api.post(`${baseUrl}/sistemas/${sistemaId}/por-a-venda`);

// Quem ganha ou perde acesso ao mover a funcionalidade para `moduloId`; sem módulo, ao removê-la.
export const getEfeitoFuncionalidade = (funcionalidadeId, moduloId) => {
    const query = buildQuery({modulo_id: moduloId});
    return api.get(`${baseUrl}/funcionalidades/${funcionalidadeId}/efeito${query ? `?${query}` : ''}`);
};

// A versão de plano traz os limites por métrica (BBF-153): o apontamento confere quem bloqueia ou tem teto.
export const getVersaoDoPlano = (planoId, numero) => api.get(`${baseUrl}/planos-licenciamento/${planoId}/versoes/${numero}`);
